import t from 'tcomb';
import Int from './Int';

const Natural = t.refinement(Int, (n) => n >= 0);

export default Natural;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Natural.js
 **/